import { ErrorReason } from '@contract';

export const ERROR_REASONS: Record<ErrorReason, string> = {
  [ErrorReason.LeadingToShot]: 'Leading to shot',
  [ErrorReason.LeadingToGoal]: 'Leading to goal',
  [ErrorReason.BigChanceMissed]: 'Big chance missed',
};
